<app-main-menu></app-main-menu>
<div class="content" style="min-width: 1200px;" disabled="disabledForm">
    <form [formGroup]="infoForm" novalidate (submit)="saveSoCai()">
        <p-panel styleClass="margin-top-10">
            <ng-template pTemplate="icons">
                <button pButton pRipple class="p-panel-header-icon p-link" (click)="homeNav()" icon="pi pi-home">
                </button>
            </ng-template>
            <ng-template pTemplate="header">
                THÔNG TIN HỒ SƠ
            </ng-template>
            <div class="card">
                <div class="p-fluid">
                    <div class="p-field p-grid">
                        <label class="p-col-2">Số công chứng gần đây: </label>
                        <div class="p-col-3">
                            <label>{{soCaiGanDayNhat.socongchung}}-{{soCaiGanDayNhat.ngaycongchung | date :'yyyy'}}</label>
                        </div>
                    </div>
                    <div class="p-field p-grid">
                        <label class="p-col-2">Số công chứng</label>
                        <div class="p-col-3">
                            <p-inputNumber formControlName="soCongChung" mode="decimal" [showButtons]="true" [min]=0
                                class="p-col-2" autofocus></p-inputNumber>
                        </div>
                        <label class="p-col-2">Ngày công chứng</label>
                        <div class="p-col-3">
                            <p-calendar formControlName="ngayCongChung" dateFormat="dd/mm/yy" [monthNavigator]="true">
                            </p-calendar>
                        </div>
                    </div>
                    <div class="p-field p-grid">
                        <label class="p-col-2">
                            Người yêu cầu
                        </label>
                        <div class="p-col-10">
                            <div class="p-col-12 p-fluid">
                                <div class="p-field p-grid" style="overflow: auto;">
                                    <div class="p-col-6 p-formgroup-inline">
                                        <!-- <div class="p-field">
                                            <button pButton pRipple type="button" icon="pi pi-list"
                                                class="p-button-raised p-button-success" (click)="showChooseNYC(true)"
                                                label="Chọn bên A..."></button>
                                        </div>
                                        <div class="p-field">
                                            <button pButton pRipple type="button" icon="pi pi-list"
                                                class="p-button-raised p-button-warning" (click)="showChooseNYC(false)"
                                                label="Chọn bên B..."></button>
                                        </div> -->
                                        <!-- <div class="p-field">
                                            <button pButton pRipple type="button" icon="pi pi-plus"
                                                class="p-button-raised p-ml-2" (click)="showAddNYC(1)"
                                                label="Thêm mới"></button>
                                        </div> -->
                                    </div>
                                    <p-splitter class="p-col-12">
                                        <ng-template pTemplate>
                                            <p-card class="p-col-12">
                                                <ng-template pTemplate="header">
                                                    <b>Bên A</b>
                                                </ng-template>
                                                <button pButton pRipple type="button" icon="pi pi-list"
                                                    style="width: 110px;margin-bottom: 10px;"
                                                    class="p-button-raised p-button-success"
                                                    (click)="showChooseNYC(true)" label="Chọn bên A..."></button>
                                                <button pButton pRipple type="button" icon="pi pi-plus"
                                                    class="p-button-raised p-ml-2" (click)="showAddNYC(1)"
                                                    style="width: 110px;margin-bottom: 10px;" label="Thêm mới"></button>
                                                <p-table [totalRecords]="nguoiYeuCau_BenA_TotalRecords"
                                                    [value]="nguoiYeuCau_BenA_Data" styleClass="p-datatable-sm"
                                                    [rowHover]="true">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <th>Bên tham gia</th>
                                                            <th>Địa chỉ</th>
                                                            <th
                                                                style="width: 50px;text-align: center; align-items: center;">
                                                                #</th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-data>
                                                        <tr>
                                                            <td>{{data.benthamgia}}</td>
                                                            <td>{{data.diachi}}</td>
                                                            <td style="text-align: center;">
                                                                <button pButton type="button" icon="fa fa-trash-o fa-lg"
                                                                    class="p-button-text"
                                                                    (click)="removeNYC(data.id,true)"></button>
                                                            </td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </p-card>
                                        </ng-template>
                                        <ng-template pTemplate>
                                            <p-card class="p-col-12">
                                                <ng-template pTemplate="header">
                                                    <b>Bên B</b>
                                                </ng-template>
                                                <button pButton pRipple type="button" icon="pi pi-list"
                                                    style="width: 110px; margin-bottom: 10px;"
                                                    class="p-button-raised p-button-warning"
                                                    (click)="showChooseNYC(false)" label="Chọn bên B..."></button>
                                                <button pButton pRipple type="button" icon="pi pi-plus"
                                                    class="p-button-raised p-ml-2" (click)="showAddNYC(0)"
                                                    style="width: 110px;margin-bottom: 10px;" label="Thêm mới"></button>
                                                <p-table [totalRecords]="nguoiYeuCau_BenB_TotalRecords"
                                                    [value]="nguoiYeuCau_BenB_Data" styleClass="p-datatable-sm"
                                                    [rowHover]="true">
                                                    <ng-template pTemplate="header">
                                                        <tr>
                                                            <th>Bên tham gia</th>
                                                            <th>Địa chỉ</th>
                                                            <th
                                                                style="width: 50px;text-align: center; align-items: center;">
                                                                #</th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-data>
                                                        <tr>
                                                            <td>{{data.benthamgia}}</td>
                                                            <td>{{data.diachi}}</td>
                                                            <td style="text-align: center;">
                                                                <button pButton type="button" icon="fa fa-trash-o fa-lg"
                                                                    class="p-button-text"
                                                                    (click)="removeNYC(data.id,false)"></button>
                                                            </td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </p-card>
                                        </ng-template>
                                    </p-splitter>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="p-field p-grid">
                        <label class="p-col-2">Loại hợp đồng</label>
                        <div class="p-col-3" [formGroup]="loaiHopDongForm">
                            <!-- <p-autoComplete formControlName="tenLoaiHopDong" [suggestions]="dataLoaiHopDong"
                                (completeMethod)="timKiemLoaiHopDong($event)" field="tenloaihopdong"
                                (onSelect)="selectedLoaiHopDong($event)">
                                <ng-template let-item pTemplate="loaihopdong_item">
                                    {{item.tenloaihopdong}}
                                </ng-template>
                            </p-autoComplete> -->
                            <p-dropdown [options]="dsLoaiHopDong" formControlName="tenLoaiHopDong"
                                placeholder="Loại hợp đồng..." optionLabel="tenloaihopdong"
                                (onChange)="loaiHDChange($event)">
                            </p-dropdown>
                        </div>
                        <label class="p-col-2">Công chứng viên</label>
                        <div class="p-col-3" [formGroup]="nhanVienForm">
                            <!-- <p-autoComplete formControlName="hoVaTen" [suggestions]="dataNhanVien"
                                (completeMethod)="timKiemNhanVien($event)" field="hovaten"
                                (onSelect)="selectedNhanVien($event)">
                                <ng-template let-item pTemplate="nhanvien_item">
                                    {{item.hovaten}}
                                </ng-template>
                            </p-autoComplete> -->
                            <p-dropdown [options]="dsCongChungVien" formControlName="hoVaTen"
                                placeholder="Công chứng viên..." optionLabel="hovaten"></p-dropdown>
                        </div>
                    </div>
                    <div class="p-field p-grid">
                        <label class="p-col-2">Phí công chứng</label>
                        <div class="p-col-3">
                            <p-inputNumber formControlName="phicongchung" mode="currency" currency="VND" locale="vi-VN">
                            </p-inputNumber>
                        </div>
                        <label class="p-col-2">Chi phí khác</label>
                        <div class="p-col-3">
                            <p-inputNumber formControlName="chiphikhac" mode="currency" currency="VND" locale="vi-VN">
                            </p-inputNumber>
                        </div>
                    </div>
                    <div class="p-field p-grid">
                        <label class="p-col-2">Thông tin tài sản</label>
                        <div class="p-col-10">
                            <textarea pInputTextarea formControlName="thongtintaisan" [rows]="5"></textarea>
                        </div>
                    </div>
                    <div class="p-field p-grid">
                        <label class="p-col-2">Người thực hiện</label>
                        <div class="p-col-3" [formGroup]="notCongChungVien">
                            <!-- <p-autoComplete formControlName="hoVaTen" [suggestions]="dataNotCongChungVien"
                                (completeMethod)="timKiemNotCongChungVien($event)" field="hovaten"
                                (onSelect)="selectedNotCongChungVien($event)">
                                <ng-template let-item pTemplate="nhanvien_item">
                                    {{item.hovaten}}
                                </ng-template>
                            </p-autoComplete> -->
                            <p-dropdown [options]="dsNhanVien" formControlName="hoVaTen" placeholder="Nhân viên..."
                                optionLabel="hovaten"></p-dropdown>
                        </div>
                        <label class="p-col-2">Cán bộ tín dụng</label>
                        <div class="p-col-3">
                            <input type="text" pInputText formControlName="canbotindung" />
                        </div>
                    </div>
                    <div class="p-field p-grid">
                        <label class="p-col-2">Ghi chú</label>
                        <div class="p-col-10">
                            <input type="text" pInputText formControlName="ghichu" />
                        </div>
                    </div>
                    <div class="p-field p-grid">
                        <label class="p-col-2">File hồ sơ</label>
                        <div class="p-col-10">
                            <input type="file" (change)="fileChange($event)" #fileUpload />
                        </div>
                    </div>
                </div>
            </div>
            <ng-template pTemplate="footer">
                <button pButton pRipple type="submit" icon="pi pi-save" label="Lưu" class="p-button-raised"></button>
                <button pButton pRipple type="button" icon="pi pi-refresh" label="Xóa thông tin" (click)="clearInput()"
                    class="p-button-raised p-button-warning p-ml-2"></button>
            </ng-template>
        </p-panel>
    </form>
</div>

<p-dialog [(visible)]="nguoiYeuCauFlag" [draggable]="true" [style]="{width: '60vw'}" [modal]="true"
    [position]="position">

    <ng-template pTemplate="header">
        <h3>Danh sách người yêu cầu</h3>
    </ng-template>
    <form [formGroup]="addNguoiYeuCauForm" (submit)="getAllNYC()" novalidate>
        <div class="p-d-flex">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" placeholder="Search..." formControlName="searchValue" autofocus />
                <!-- nguoiYeuCau_Choose_SearchValue -->
            </span>
            <button pButton pRipple type="submit" icon="pi pi-search" label="Tìm kiếm"
                class="p-button-raised p-ml-1"></button>
        </div>
    </form>
    <p-table [paginator]="true" [rows]="nguoiYeuCau_Choose_PageSize" [totalRecords]="nguoiYeuCau_Choose_TotalRecords"
        [loading]="nguoiYeuCau_Choose_Loading" [lazy]="true" [rowsPerPageOptions]="[10,25,50]"
        [value]="nguoiYeuCau_Choose_Data" [(first)]="nguoiYeuCau_Choose_PageNumber" styleClass="p-datatable-sm"
        (onLazyLoad)="getNYC($event)" [rowHover]="true" [(selection)]="nguoiYeuCau_Choose_Choosed">
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 3rem">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>Bên tham gia</th>
                <th>Địa chỉ</th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data>
            <tr>
                <td>
                    <p-tableCheckbox [value]="data"></p-tableCheckbox>
                </td>
                <td>{{data.benthamgia}}</td>
                <td>{{data.diachi}}</td>
            </tr>
        </ng-template>
    </p-table>
    <p-footer>
        <button pButton pRipple type="button" label="Chọn" (click)="chooseNYC()"
            class="p-button-raised p-button-text p-button-success"><i class="pi pi-check"></i>&nbsp;</button>
        <button pButton pRipple type="button" label="Chọn lại" (click)="clearChoosed()"
            class="p-button-raised p-button-text p-button-warning"><i class="pi pi-refresh"></i>&nbsp;</button>
        <button pButton pRipple type="button" label="Đóng" (click)="closeChooseNYC()"
            class="p-button-raised p-button-text"><i class="pi pi-times"></i>&nbsp;</button>
    </p-footer>
</p-dialog>
<form novalidate [formGroup]="nguoiYeuCauFormGroup">
    <p-dialog [(visible)]="addNYCFlag" [draggable]="true" [style]="{width: '50vw'}" [modal]="true"
        [position]="position">
        <ng-template pTemplate="header">
            <h3>Thông tin người yêu cầu</h3>
        </ng-template>
        <div class="p-fluid">
            <div class="p-field">
                <label for="tt_benA">Bên:</label>
                <p-dropdown [options]="nguoiYeuCau_Add_Option" formControlName="loaiben" optionLabel="text"
                    optionValue="val" [autoDisplayFirst]="true"></p-dropdown>
            </div>
            <div class="p-field">
                <label for="tt_benA">Bên tham gia</label>
                <!-- <input id="tt_benThamGia" type="text" pInputText formControlName="benThamGia"> -->
                <textarea pInputTextarea formControlName="benthamgia" [rows]="5"></textarea>
            </div>
            <div class="p-field">
                <label for="tt_benA_diaChi">Địa chỉ</label>
                <textarea pInputTextarea formControlName="diachi" [rows]="5"></textarea>
            </div>
        </div>
        <p-footer>
            <button pButton pRipple type="button" label="Thêm" (click)="addNYC()"
                class="p-button-raised p-button-text"><i class="pi pi-save"></i>&nbsp;</button>
        </p-footer>
    </p-dialog>
</form>

<form novalidate [formGroup]="addLoaiHDFormGroup">
    <p-dialog [(visible)]="addLHDFlag" [draggable]="true" [style]="{width: '30vw'}" [modal]="true"
        [position]="position">
        <ng-template pTemplate="header">
            <h3>Thông tin loại hợp đồng</h3>
        </ng-template>
        <div class="p-fluid">
            <div class="p-field">
                <label for="tt_tenLoaiHD">Tên loại hợp đồng:</label>
                <input id="tt_tenLoaiHD" type="text" pInputText formControlName="tenLoaiHopDong">
            </div>
        </div>
        <p-footer>
            <button pButton pRipple type="button" label="Thêm" (click)="addLoaiHD()"
                class="p-button-raised p-button-text"><i class="pi pi-save"></i>&nbsp;</button>
        </p-footer>
    </p-dialog>
</form>
<p-toast position="top-right"></p-toast>